import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import type { SwitchRequestSource } from '../../../../types/drug-config';

import { useKeepCurrent } from './use-keep-current';

export const KeepCurrentButton = ({
    disabled,
    drxId,
    requestSource,
}: {
    disabled?: boolean;
    drxId: string;
    requestSource: SwitchRequestSource;
}) => {
    const { t } = useTranslation();
    const { keepCurrent } = requestSource;

    const [isModalOpen, { open, close }] = useDisclosure(false);

    const handleNavigateBack = useKeepCurrent(drxId, requestSource);

    const handleButtonClick = useCallback(() => {
        if (keepCurrent.modal) {
            open();
        } else {
            handleNavigateBack();
        }
    }, [handleNavigateBack, keepCurrent.modal, open]);

    return (
        <>
            <Button
                variant="outline"
                size="lg"
                disabled={disabled}
                onClick={handleButtonClick}
            >
                {t('fill.switch.cta.keepCurrent')}
            </Button>

            {keepCurrent.modal && (
                <Modal
                    opened={isModalOpen}
                    onClose={close}
                    title={keepCurrent.modal.title}
                >
                    <Stack gap="xl">
                        <Stack gap="xs">
                            {keepCurrent.modal.description.map((line) => (
                                <Body1 key={line}>
                                    <Trans
                                        ns="dynamic"
                                        components={{ b: <strong /> }}
                                    >
                                        {line}
                                    </Trans>
                                </Body1>
                            ))}
                        </Stack>
                        <Button onClick={handleNavigateBack}>
                            {t('fill.switch.cta.keepCurrent')}
                        </Button>
                    </Stack>
                </Modal>
            )}
        </>
    );
};
